import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Services from '../views/Services.vue';
import Contact from '../views/Contact.vue';

import Shipping from '../views/Shipping.vue';
import RefrigeratedGoods from '../views/RefrigeratedGoods.vue';
import OperableGoods from '../views/OperableGoods.vue';
import Consultation from '../views/Consultation.vue';
import Business from '../views/Business.vue';
import Careers from '../views/Careers.vue';

Vue.use(Router);

export default new Router({
	routes: [{
			path: '/',
			component: Home
		},
		{
			path: '/about',
			component: About
		},
		{
			path: '/services',
			component: Services,
			children: [{
					path: 'shipping',
					component: Shipping
				},
				{
					path: 'refrigerated',
					component: RefrigeratedGoods
				},
				{
					path: 'operable',
					component: OperableGoods
				},
				{
					path: 'consultation',
					component: Consultation
				},
			],
		},
		{
			path: '/contact',
			component: Contact,
			children: [{
					path: 'business',
					component: Business
				},
				{
					path: 'careers',
					component: Careers
				},
			]
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			};
		}
		return {
			x: 0,
			y: 0
		};
	},
});